import {
  
    UPDATE_ITEM,
    SET_PROJECT,
    SET_MY_PROJECT,
    SET_TDK_PROJECT,
    SET_SELECTED_PROJECT
} from "constants/ActionTypes";

const INIT_STATE = {
    item: null,
    isUpdate: false,
    myProjects:localStorage.getItem("myProject")===null ? [] :  JSON.parse(localStorage.getItem("myProject")),
    projects:localStorage.getItem("projects")===null ? [] :  JSON.parse(localStorage.getItem("projects")),
    TDKprojects:localStorage.getItem("TDKprojects")===null ? [] :  JSON.parse(localStorage.getItem("TDKprojects")),
    selectedProject:localStorage.getItem("selectedProject")===null ? null :  JSON.parse(localStorage.getItem("selectedProject"))

};


export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case UPDATE_ITEM: {
            return {
                ...state,
                item: action.payload.item,
                isUpdate: action.payload.isUpdate,
            }
        }
        case SET_PROJECT: {
            localStorage.setItem("projects",JSON.stringify(action.payload.projects));

            return {
                ...state,
                projects: action.payload.projects,
            }
        }
        case SET_MY_PROJECT: {
            localStorage.setItem("myProject",JSON.stringify(action.payload.myProjects));
            return {
                ...state,
                myProjects: action.payload.myProjects,
            }
        }
        case SET_TDK_PROJECT: {
            localStorage.setItem("TDKprojects",JSON.stringify(action.payload.projects));
            return {
                ...state,
                TDKprojects: action.payload.projects,
            }
        }
        case SET_SELECTED_PROJECT: {
            localStorage.setItem("selectedProject",JSON.stringify(action.payload.selectedProject));
            return {
                ...state,
                selectedProject: action.payload.selectedProject,
            }
        }
 
        default:
            return state;
    }
}
